import AxiosInstance from "../Utils/axios/axiosConfig";
import axios from "axios";
// import {IMAGE_BASE_URL} from "../Constants/serverAddress"

const imageUploadAxios = axios.create({
    // baseURL:IMAGE_BASE_URL
})

imageUploadAxios.interceptors.response.use(
    (res) => {
        res.header('Access-Control-Allow-Credentials', "*");
        return res;
    },)

export const  editProfile = (body)=> {
    return AxiosInstance.put(`/profile-settings/`, body)
}

export const getProfile = ()=> {
    return AxiosInstance.get(`/profile-settings/`);
}

export const uploadImage = (file)=> {
    return imageUploadAxios.put(`${file.name}`,file)
}